import cx from 'classnames'
import * as React from 'react'

import { angleDown, angleUp } from '../../icons/index'
import { trackEvent } from '../../utils/gtag'
import BaseButton from '../BaseButton/BaseButton'
import Icon from '../Icon/Icon'
import styles from './dropdown-style.css'

type Props = {
  children?: React.ReactNode
  title?: any
  className?: string
  name?: string
}
type State = {
  showMenu: boolean
}

class Dropdown extends React.Component<Props, State> {
  static displayName = 'Dropdown'
  static defaultProps = {}
  dropdownMenu: HTMLDivElement

  state = {
    showMenu: false,
  }

  handleShowMenu = (event: MouseEvent) => {
    event.preventDefault()
    this.setState(
      {
        showMenu: true,
      },
      () => {
        document.addEventListener('click', this.handleCloseMenu)
      },
    )
  }
  handleCloseMenu = (event: MouseEvent) => {
    if (!this.dropdownMenu?.contains(event.target as any)) {
      this.setState(
        {
          showMenu: false,
        },
        () => {
          document.removeEventListener('click', this.handleCloseMenu)
        },
      )
    }
  }

  componentDidUpdate(prevProps: any, prevState: any): void {
    if (prevState.showMenu !== this.state.showMenu && this.state.showMenu === true) {
      if (this.props.name === 'service-menu') {
        trackEvent({
          event: 'desktop-menu-dropdown',
        })
      }
    }
  }

  setRef = (el: any) => {
    this.dropdownMenu = el
  }

  renderTitle(title: any, showMenu: boolean) {
    const type = typeof title

    if (type === 'string') {
      return (
        <BaseButton
          className={cx(styles.title, {
            [styles.active]: showMenu,
          })}
          onClick={this.handleShowMenu}
        >
          <span>{title}</span>{' '}
          <Icon iconSrc={showMenu ? angleUp : angleDown} height="16px" width="16px" />
        </BaseButton>
      )
    } else {
      return title(this.handleShowMenu, showMenu)
    }
  }

  render() {
    const { children, title, className } = this.props
    const { showMenu } = this.state

    return (
      <div className={cx(styles.dropdown, className)}>
        {title && this.renderTitle(title, showMenu)}
        {showMenu && (
          <div className={styles.dropdownLinks} ref={this.setRef}>
            {children}
          </div>
        )}
      </div>
    )
  }
}

export default Dropdown